import { API_ROUTES } from "../utils/constants"
import apiHelper from "./apiHelper"

export function createJts3User(data) {
    return apiHelper({ method: "post", path: API_ROUTES.JTS3.CREATE, data })
}

export function activate({ userId }) {
    return apiHelper({ method: "post", path: API_ROUTES.JTS3.ACTIVATE, data: { userId } })
}

export function suspend({ userId }) {
    return apiHelper({ method: "post", path: API_ROUTES.JTS3.SUSPEND, data: { userId } })
}

export function extend({ userId }) {
    return apiHelper({ method: "post", path: API_ROUTES.JTS3.EXTEND, data: { userId } })
}
export function editJts3User(data) {
    return apiHelper({ method: "post", path: API_ROUTES.JTS3.EDIT, data })
}

export function deleteJts3User({ userId }) {
    return apiHelper({ method: "delete", path: API_ROUTES.JTS3.DELETE, data: { userId } })
}

export function updateJts3Settings(data) {
    return apiHelper({ method: "post", path: API_ROUTES.JTS3.UPDATE_SETTINGS, data })
}

export function getJts3Settings() {
    return apiHelper({ method: "get", path: API_ROUTES.JTS3.GET_SETTINGS })
}
